"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _usePreview = require("./usePreview");

Object.keys(_usePreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePreview[key];
    }
  });
});